import React from 'react';

import CalculatorCore, {Props} from './CalculatorCore';
import SubjectQCE from './SubjectQCE';
import {Subject} from '../types';

export default class CalculatorQCE extends React.Component<Props> {
  render() {
    return (
      <CalculatorCore {...this.props} subjectRenderer={this._renderSubject} />
    );
  }

  _renderSubject(subject: Subject) {
    return (
      <SubjectQCE
        key={subject.ID_SUBJECT}
        subject={subject}
        onDeleteSubject={this.props.onDeleteSubject}
        onUpdateSubject={this.props.onUpdateSubject}
      />
    );
  }
}
